import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { CheckmarkCircle, MinusCircled, PauseCircled, Truck, Plane } from '@bibliocommons/deprecated-base-icons';

import { INTER_LIBRARY_STATUS_TYPES } from 'app/constants/InterlibraryLoansConstants';

import BorrowingStatusIcon from '../../shared/BorrowingStatusIcon';

const getIcon = status => {
  switch (status) {
    case INTER_LIBRARY_STATUS_TYPES.READY:
      return <CheckmarkCircle />;
    case INTER_LIBRARY_STATUS_TYPES.IN_TRANSIT:
      return <Truck />;
    case INTER_LIBRARY_STATUS_TYPES.INACTIVE:
      return <PauseCircled />;
    case INTER_LIBRARY_STATUS_TYPES.SHIPPED:
      return <Plane />;
    default:
      return <MinusCircled />;
  }
};

export default function InterlibraryLoansStatusIcon({ status, withBackground, withLabel }) {
  const label = status && <FormattedMessage id={`ill_status_${status.toLowerCase()}`} />;

  return (
    <BorrowingStatusIcon
      className="cp-interlibraryloans-status-icon"
      icon={getIcon(status)}
      status={status}
      withBackground={withBackground}
      renderLabel={withLabel && (() => label)}
    />
  );
}

InterlibraryLoansStatusIcon.propTypes = {
  status: PropTypes.string.isRequired,
  withBackground: PropTypes.bool,
  withLabel: PropTypes.bool
};
